<template>
  <div>
    <h3 class="title">
      {{ title }}
    </h3>
    <p class="message">
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'TitleMessage',

  props: {
    question: {
      type: Object,
      required: true
    },
    answer: {
      type: Object,
      required: true
    }
  },

  computed: {
    title () {
      return this.question.message.config.title
    },
    message () {
      return this.question.message.config.value
    }
  }
}
</script>

<style lang="scss" scoped>
  .title {
    color: #152D72;
    font-weight: bold;
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 4px;

     @media (min-width: $screen-md) {
      font-size: 24px;
      line-height: 30px;
      margin-bottom: 14px;
     }
  }

  .message {
    color: #000000;
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 12px;

    @media (min-width: $screen-md) {
      width: 375px;
      font-size: 18px;
      line-height: 22px;
    }
  }
</style>
